import React from 'react';

/** Compact chip for appointment vs walk-in queue priority. */
export default function QueuePriorityBadge({ entry }) {
  const walkin = entry?.is_walkin === true
    || (entry?.queue_priority || '') === 'walkin'
    || (entry?.booking_mode || '').toLowerCase().replace(/[-_]/g, '') === 'walkin';
  return (
    <span
      className={`text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded border ${
        walkin
          ? 'bg-zinc-50 text-zinc-600 border-zinc-200'
          : 'bg-sky-50 text-sky-800 border-sky-200'
      }`}
      data-testid="queue-priority-badge"
    >
      {walkin ? 'Walk-in' : 'Appointment'}
    </span>
  );
}
